import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class BasketService {
  baseUrl = 'basket';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  activate = (id) => BaseService.post({ url: `${this.baseUrl}/activate/${id}` });
  delete = (id) => BaseService.post({ url: `${this.baseUrl}/delete/${id}` });
  save = (user) => BaseService.post({ url: `${this.baseUrl}/save`, data: user });
  getAvailableContentTypes = (id, includeAllVersions) => BaseService.get({ url: `${this.baseUrl}/get-available-content-types/${id}/${includeAllVersions || false}` });
  getDocumentCount = (dashboardItemDTO) => BaseService.post({ url: `${this.baseUrl}/get-document-count`, data: dashboardItemDTO });
  saveGroupSettingsForBasket = (basketId, groupSettings) => BaseService.post({ url: `${this.baseUrl}/${basketId}/group-settings`, data: groupSettings });
  getGroupSettingsForBasket = (basketId) => BaseService.get({ url: `${this.baseUrl}/${basketId}/get-group-settings` });
}

export default new BasketService()
